import { applyClusterMetricFilter } from '@process-advisor/process-miner/api/methods/cluster/applyClusterMetricFilter';
import { setClusterAttributes } from '@process-advisor/process-miner/api/methods/cluster/setClusterAttributes';
import { applyClusterValueFilter } from '@process-advisor/process-miner/api/methods/cluster/applyClusterValueFilter';
import { setDiagramCluster } from '@process-advisor/process-miner/api/methods/cluster/setDiagramCluster'
import { setClusterMinMaxMetric } from '@process-advisor/process-miner/api/methods/cluster/setMinMaxMetric'
import { getClusterMinMaxMetric } from '@process-advisor/process-miner/api/methods/cluster/setMinMaxMetric'
import { setClusterMinMaxTasks } from '@process-advisor/process-miner/api/methods/cluster/setMinMaxTasks'
import { getClusterMinMaxTasks } from '@process-advisor/process-miner/api/methods/cluster/setMinMaxTasks'
import { setClusterShowSteps } from '@process-advisor/process-miner/api/methods/cluster/setShowSteps'
import { getClusterShowSteps } from '@process-advisor/process-miner/api/methods/cluster/setShowSteps'
import { updateDiagramCluster } from '@process-advisor/process-miner/api/methods/cluster/updateDiagramCluster'


export const clusterMethods = {
    applyClusterMetricFilter,
    setClusterAttributes,
    setDiagramCluster,
    applyClusterValueFilter,
    setClusterMinMaxMetric,
    getClusterMinMaxMetric,
    setClusterMinMaxTasks,
    getClusterMinMaxTasks,
    setClusterShowSteps,
    getClusterShowSteps,
    updateDiagramCluster
};
